module.exports = __webpack_public_path__ + "static/fifth-28a74d7d8a758f71ecacb4e0ca4d139c.jpg";